import type { SVGProps } from "react";
import * as React from "react";

const SvgCompass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m16.24 7.76.949.316a1 1 0 0 0-1.265-1.265zm-2.12 6.36.316.949a1 1 0 0 0 .633-.633zm-6.36 2.12-.949-.316a1 1 0 0 0 1.265 1.265zm2.12-6.36-.316-.949a1 1 0 0 0-.633.633zM21 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm3.291 4.444-2.12 6.36 1.898.632 2.12-6.36zm-1.487 5.727-6.36 2.12.632 1.898 6.36-2.12zm-5.095 3.385 2.12-6.36-1.898-.632-2.12 6.36zm1.487-5.727 6.36-2.12-.632-1.898-6.36 2.12z"
    />
  </svg>
);
export default SvgCompass;
